const Arrow = () => {
  return (
    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.928771 8.99925L4.83008 5.07031L0.901136 1.16901"
        stroke="#000C37"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
};

export { Arrow };
